export const CLEAR_ANNOUNCEMENT_TIMEOUT = 500;
export const BALLOON_CLOSE_TIMEOUT = 500;
export const BALLOON_MAX_HEIGHT_SPACER = 12;